import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from "../../app.component";

@Component({
  selector: 'app-logos-unlogged',
  templateUrl: './logos-unlogged.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./logos-unlogged.component.less']
})
export class LogosUnloggedComponent implements OnInit {
  global_texts: any = null;

  constructor(
    public app: AppComponent,) {
  }

  ngOnInit(): void {
    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      console.log("texts ==> ", texts);
      this.global_texts = texts;
    });
  }
}
